/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Artifact } from '../models/artifact';
import { ImageOverrideRequest } from '../models/image-override-request';
import { ArtifactRequest } from '../models/artifact-request';
import { ECRAuthorizationData } from '../models/ecrauthorization-data';
import { ArtifactByEnvironmentRequest } from '../models/artifact-by-environment-request';
import { ArtifactByReleaseStreamRequest } from '../models/artifact-by-release-stream-request';
import { SaasArtifactRequest } from '../models/saas-artifact-request';

/**
 * Ui Artifacts Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiArtifactsControllerService extends __BaseService {
  static readonly getAllUsingGETPath = '/cc-ui/v1/artifacts';
  static readonly attachImageViaRegisterUsingPOSTPath =
    '/cc-ui/v1/artifacts/attach-image-via-register';
  static readonly getArtifactByApplicationNameUsingGETPath =
    '/cc-ui/v1/artifacts/cluster/{clusterId}/application/{applicationName}';
  static readonly getArtifactsByResourceNameAndResourceTypeUsingGETPath =
    '/cc-ui/v1/artifacts/cluster/{clusterId}/resourceType/{resourceType}/resourceName/{resourceName}';
  static readonly updateReleaseStreamUsingPOSTPath =
    '/cc-ui/v1/artifacts/clusterId/{clusterId}/currentReleaseStream/{currentReleaseStream}/updatedReleaseStream/{updatedReleaseStream}/updateStream';
  static readonly getMetadataKeysUsingGETPath =
    '/cc-ui/v1/artifacts/metadata/keys';
  static readonly promoteArtifactByArtifactCiNameUsingPOSTPath =
    '/cc-ui/v1/artifacts/promote';
  static readonly pushArtifactUsingPOSTPath = '/cc-ui/v1/artifacts/push';
  static readonly generateArtifactPushCredentialsUsingPOSTPath =
    '/cc-ui/v1/artifacts/pushCredentials/{stackName}/{appName}';
  static readonly generateArtifactPushCredentialsV2UsingPOSTPath =
    '/cc-ui/v1/artifacts/pushCredentialsV2/artifactName/{artifactName}/registrationType/{registrationType}/value/{registrationValue}';
  static readonly generateArtifactPushCredentialsV3UsingPOSTPath =
    '/cc-ui/v1/artifacts/pushCredentialsV3/artifactName/{artifactName}';
  static readonly reclassifyArtifactsUsingPUTPath =
    '/cc-ui/v1/artifacts/reclassify';
  static readonly registerArtifactUsingPOST1Path =
    '/cc-ui/v1/artifacts/register';
  static readonly registerArtifactByEnvUsingPOSTPath =
    '/cc-ui/v1/artifacts/register-by-env';
  static readonly registerArtifactByReleaseStreamUsingPOSTPath =
    '/cc-ui/v1/artifacts/register-by-release-stream';
  static readonly registerArtifactSaasUsingPOSTPath =
    '/cc-ui/v1/artifacts/register-saas';
  static readonly registerArtifactV2UsingPOSTPath =
    '/cc-ui/v1/artifacts/registerV2';
  static readonly uploadArtifactsZipUsingPOSTPath =
    '/cc-ui/v1/artifacts/upload';
  static readonly deleteArtifactUsingDELETEPath =
    '/cc-ui/v1/artifacts/{artifactId}';
  static readonly promoteArtifactUsingPOSTPath =
    '/cc-ui/v1/artifacts/{ciId}/promote/{artifactId}';
  static readonly getArtifactByClusterIdUsingGETPath =
    '/cc-ui/v1/artifacts/{clusterId}';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAll
   * @param params The `UiArtifactsControllerService.GetAllUsingGETParams` containing the following parameters:
   *
   * - `classified`: classified
   *
   * - `artifactory`: artifactory
   *
   * @return OK
   */
  getAllUsingGETResponse(
    params: UiArtifactsControllerService.GetAllUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<Artifact>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.classified != null)
      __params = __params.set('classified', params.classified.toString());
    if (params.artifactory != null)
      __params = __params.set('artifactory', params.artifactory.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/artifacts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Artifact>>;
      }),
    );
  }
  /**
   * getAll
   * @param params The `UiArtifactsControllerService.GetAllUsingGETParams` containing the following parameters:
   *
   * - `classified`: classified
   *
   * - `artifactory`: artifactory
   *
   * @return OK
   */
  getAllUsingGET(
    params: UiArtifactsControllerService.GetAllUsingGETParams,
  ): __Observable<Array<Artifact>> {
    return this.getAllUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<Artifact>),
    );
  }

  /**
   * attachImageViaRegister
   * @param request request
   */
  attachImageViaRegisterUsingPOSTResponse(
    request: ImageOverrideRequest,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifacts/attach-image-via-register`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * attachImageViaRegister
   * @param request request
   */
  attachImageViaRegisterUsingPOST(
    request: ImageOverrideRequest,
  ): __Observable<null> {
    return this.attachImageViaRegisterUsingPOSTResponse(request).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * getArtifactByApplicationName
   * @param params The `UiArtifactsControllerService.GetArtifactByApplicationNameUsingGETParams` containing the following parameters:
   *
   * - `clusterId`: clusterId
   *
   * - `applicationName`: applicationName
   *
   * @return OK
   */
  getArtifactByApplicationNameUsingGETResponse(
    params: UiArtifactsControllerService.GetArtifactByApplicationNameUsingGETParams,
  ): __Observable<__StrictHttpResponse<Artifact>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/artifacts/cluster/${encodeURIComponent(
          String(params.clusterId),
        )}/application/${encodeURIComponent(String(params.applicationName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Artifact>;
      }),
    );
  }
  /**
   * getArtifactByApplicationName
   * @param params The `UiArtifactsControllerService.GetArtifactByApplicationNameUsingGETParams` containing the following parameters:
   *
   * - `clusterId`: clusterId
   *
   * - `applicationName`: applicationName
   *
   * @return OK
   */
  getArtifactByApplicationNameUsingGET(
    params: UiArtifactsControllerService.GetArtifactByApplicationNameUsingGETParams,
  ): __Observable<Artifact> {
    return this.getArtifactByApplicationNameUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Artifact),
    );
  }

  /**
   * getArtifactsByResourceNameAndResourceType
   * @param params The `UiArtifactsControllerService.GetArtifactsByResourceNameAndResourceTypeUsingGETParams` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getArtifactsByResourceNameAndResourceTypeUsingGETResponse(
    params: UiArtifactsControllerService.GetArtifactsByResourceNameAndResourceTypeUsingGETParams,
  ): __Observable<__StrictHttpResponse<Artifact>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/artifacts/cluster/${encodeURIComponent(
          String(params.clusterId),
        )}/resourceType/${encodeURIComponent(
          String(params.resourceType),
        )}/resourceName/${encodeURIComponent(String(params.resourceName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Artifact>;
      }),
    );
  }
  /**
   * getArtifactsByResourceNameAndResourceType
   * @param params The `UiArtifactsControllerService.GetArtifactsByResourceNameAndResourceTypeUsingGETParams` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getArtifactsByResourceNameAndResourceTypeUsingGET(
    params: UiArtifactsControllerService.GetArtifactsByResourceNameAndResourceTypeUsingGETParams,
  ): __Observable<Artifact> {
    return this.getArtifactsByResourceNameAndResourceTypeUsingGETResponse(
      params,
    ).pipe(__map((_r) => _r.body as Artifact));
  }

  /**
   * updateReleaseStream
   * @param params The `UiArtifactsControllerService.UpdateReleaseStreamUsingPOSTParams` containing the following parameters:
   *
   * - `updatedReleaseStream`: updatedReleaseStream
   *
   * - `includeApps`: includeApps
   *
   * - `excludeApps`: excludeApps
   *
   * - `currentReleaseStream`: currentReleaseStream
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  updateReleaseStreamUsingPOSTResponse(
    params: UiArtifactsControllerService.UpdateReleaseStreamUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    (params.includeApps || []).forEach((val) => {
      if (val != null)
        __params = __params.append('includeApps', val.toString());
    });
    (params.excludeApps || []).forEach((val) => {
      if (val != null)
        __params = __params.append('excludeApps', val.toString());
    });

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/artifacts/clusterId/${encodeURIComponent(
          String(params.clusterId),
        )}/currentReleaseStream/${encodeURIComponent(
          String(params.currentReleaseStream),
        )}/updatedReleaseStream/${encodeURIComponent(
          String(params.updatedReleaseStream),
        )}/updateStream`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      }),
    );
  }
  /**
   * updateReleaseStream
   * @param params The `UiArtifactsControllerService.UpdateReleaseStreamUsingPOSTParams` containing the following parameters:
   *
   * - `updatedReleaseStream`: updatedReleaseStream
   *
   * - `includeApps`: includeApps
   *
   * - `excludeApps`: excludeApps
   *
   * - `currentReleaseStream`: currentReleaseStream
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  updateReleaseStreamUsingPOST(
    params: UiArtifactsControllerService.UpdateReleaseStreamUsingPOSTParams,
  ): __Observable<{}> {
    return this.updateReleaseStreamUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as {}),
    );
  }

  /**
   * getMetadataKeys
   * @return OK
   */
  getMetadataKeysUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<string>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/artifacts/metadata/keys`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getMetadataKeys
   * @return OK
   */
  getMetadataKeysUsingGET(): __Observable<Array<string>> {
    return this.getMetadataKeysUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<string>),
    );
  }

  /**
   * promoteArtifactByArtifactCiName
   * @param params The `UiArtifactsControllerService.PromoteArtifactByArtifactCiNameUsingPOSTParams` containing the following parameters:
   *
   * - `ciName`: ciName
   *
   * - `artifactId`: artifactId
   *
   * @return OK
   */
  promoteArtifactByArtifactCiNameUsingPOSTResponse(
    params: UiArtifactsControllerService.PromoteArtifactByArtifactCiNameUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<Artifact>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.ciName != null)
      __params = __params.set('ciName', params.ciName.toString());
    if (params.artifactId != null)
      __params = __params.set('artifactId', params.artifactId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifacts/promote`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Artifact>;
      }),
    );
  }
  /**
   * promoteArtifactByArtifactCiName
   * @param params The `UiArtifactsControllerService.PromoteArtifactByArtifactCiNameUsingPOSTParams` containing the following parameters:
   *
   * - `ciName`: ciName
   *
   * - `artifactId`: artifactId
   *
   * @return OK
   */
  promoteArtifactByArtifactCiNameUsingPOST(
    params: UiArtifactsControllerService.PromoteArtifactByArtifactCiNameUsingPOSTParams,
  ): __Observable<Artifact> {
    return this.promoteArtifactByArtifactCiNameUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as Artifact),
    );
  }

  /**
   * pushArtifact
   * @param artifactRequest artifactRequest
   */
  pushArtifactUsingPOSTResponse(
    artifactRequest: ArtifactRequest,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = artifactRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifacts/push`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * pushArtifact
   * @param artifactRequest artifactRequest
   */
  pushArtifactUsingPOST(artifactRequest: ArtifactRequest): __Observable<null> {
    return this.pushArtifactUsingPOSTResponse(artifactRequest).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * generateArtifactPushCredentials
   * @param params The `UiArtifactsControllerService.GenerateArtifactPushCredentialsUsingPOSTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `appName`: appName
   *
   * @return OK
   */
  generateArtifactPushCredentialsUsingPOSTResponse(
    params: UiArtifactsControllerService.GenerateArtifactPushCredentialsUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<ECRAuthorizationData>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/artifacts/pushCredentials/${encodeURIComponent(
          String(params.stackName),
        )}/${encodeURIComponent(String(params.appName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ECRAuthorizationData>;
      }),
    );
  }
  /**
   * generateArtifactPushCredentials
   * @param params The `UiArtifactsControllerService.GenerateArtifactPushCredentialsUsingPOSTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `appName`: appName
   *
   * @return OK
   */
  generateArtifactPushCredentialsUsingPOST(
    params: UiArtifactsControllerService.GenerateArtifactPushCredentialsUsingPOSTParams,
  ): __Observable<ECRAuthorizationData> {
    return this.generateArtifactPushCredentialsUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as ECRAuthorizationData),
    );
  }

  /**
   * generateArtifactPushCredentialsV2
   * @param params The `UiArtifactsControllerService.GenerateArtifactPushCredentialsV2UsingPOSTParams` containing the following parameters:
   *
   * - `registrationValue`: registrationValue
   *
   * - `registrationType`: registrationType
   *
   * - `artifactName`: artifactName
   *
   * @return OK
   */
  generateArtifactPushCredentialsV2UsingPOSTResponse(
    params: UiArtifactsControllerService.GenerateArtifactPushCredentialsV2UsingPOSTParams,
  ): __Observable<__StrictHttpResponse<ECRAuthorizationData>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/artifacts/pushCredentialsV2/artifactName/${encodeURIComponent(
          String(params.artifactName),
        )}/registrationType/${encodeURIComponent(
          String(params.registrationType),
        )}/value/${encodeURIComponent(String(params.registrationValue))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ECRAuthorizationData>;
      }),
    );
  }
  /**
   * generateArtifactPushCredentialsV2
   * @param params The `UiArtifactsControllerService.GenerateArtifactPushCredentialsV2UsingPOSTParams` containing the following parameters:
   *
   * - `registrationValue`: registrationValue
   *
   * - `registrationType`: registrationType
   *
   * - `artifactName`: artifactName
   *
   * @return OK
   */
  generateArtifactPushCredentialsV2UsingPOST(
    params: UiArtifactsControllerService.GenerateArtifactPushCredentialsV2UsingPOSTParams,
  ): __Observable<ECRAuthorizationData> {
    return this.generateArtifactPushCredentialsV2UsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as ECRAuthorizationData),
    );
  }

  /**
   * generateArtifactPushCredentialsV3
   * @param params The `UiArtifactsControllerService.GenerateArtifactPushCredentialsV3UsingPOSTParams` containing the following parameters:
   *
   * - `metadata`: metadata
   *
   * - `artifactName`: artifactName
   *
   * @return OK
   */
  generateArtifactPushCredentialsV3UsingPOSTResponse(
    params: UiArtifactsControllerService.GenerateArtifactPushCredentialsV3UsingPOSTParams,
  ): __Observable<__StrictHttpResponse<ECRAuthorizationData>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.metadata != null)
      __params = __params.set('metadata', params.metadata.toString());

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/artifacts/pushCredentialsV3/artifactName/${encodeURIComponent(
          String(params.artifactName),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ECRAuthorizationData>;
      }),
    );
  }
  /**
   * generateArtifactPushCredentialsV3
   * @param params The `UiArtifactsControllerService.GenerateArtifactPushCredentialsV3UsingPOSTParams` containing the following parameters:
   *
   * - `metadata`: metadata
   *
   * - `artifactName`: artifactName
   *
   * @return OK
   */
  generateArtifactPushCredentialsV3UsingPOST(
    params: UiArtifactsControllerService.GenerateArtifactPushCredentialsV3UsingPOSTParams,
  ): __Observable<ECRAuthorizationData> {
    return this.generateArtifactPushCredentialsV3UsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as ECRAuthorizationData),
    );
  }

  /**
   * reclassifyArtifacts
   * @param artifactCiId artifactCiId
   */
  reclassifyArtifactsUsingPUTResponse(
    artifactCiId: string,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (artifactCiId != null)
      __params = __params.set('artifactCiId', artifactCiId.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/cc-ui/v1/artifacts/reclassify`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * reclassifyArtifacts
   * @param artifactCiId artifactCiId
   */
  reclassifyArtifactsUsingPUT(artifactCiId: string): __Observable<null> {
    return this.reclassifyArtifactsUsingPUTResponse(artifactCiId).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * registerArtifact
   * @param artifact artifact
   * @return OK
   */
  registerArtifactUsingPOST1Response(
    artifact: Artifact,
  ): __Observable<__StrictHttpResponse<Array<Artifact>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = artifact;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifacts/register`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Artifact>>;
      }),
    );
  }
  /**
   * registerArtifact
   * @param artifact artifact
   * @return OK
   */
  registerArtifactUsingPOST1(
    artifact: Artifact,
  ): __Observable<Array<Artifact>> {
    return this.registerArtifactUsingPOST1Response(artifact).pipe(
      __map((_r) => _r.body as Array<Artifact>),
    );
  }

  /**
   * registerArtifactByEnv
   * @param artifactRequest artifactRequest
   */
  registerArtifactByEnvUsingPOSTResponse(
    artifactRequest: ArtifactByEnvironmentRequest,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = artifactRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifacts/register-by-env`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * registerArtifactByEnv
   * @param artifactRequest artifactRequest
   */
  registerArtifactByEnvUsingPOST(
    artifactRequest: ArtifactByEnvironmentRequest,
  ): __Observable<null> {
    return this.registerArtifactByEnvUsingPOSTResponse(artifactRequest).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * registerArtifactByReleaseStream
   * @param artifactRequest artifactRequest
   */
  registerArtifactByReleaseStreamUsingPOSTResponse(
    artifactRequest: ArtifactByReleaseStreamRequest,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = artifactRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifacts/register-by-release-stream`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * registerArtifactByReleaseStream
   * @param artifactRequest artifactRequest
   */
  registerArtifactByReleaseStreamUsingPOST(
    artifactRequest: ArtifactByReleaseStreamRequest,
  ): __Observable<null> {
    return this.registerArtifactByReleaseStreamUsingPOSTResponse(
      artifactRequest,
    ).pipe(__map((_r) => _r.body as null));
  }

  /**
   * registerArtifactSaas
   * @param artifactRequest artifactRequest
   */
  registerArtifactSaasUsingPOSTResponse(
    artifactRequest: SaasArtifactRequest,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = artifactRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifacts/register-saas`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * registerArtifactSaas
   * @param artifactRequest artifactRequest
   */
  registerArtifactSaasUsingPOST(
    artifactRequest: SaasArtifactRequest,
  ): __Observable<null> {
    return this.registerArtifactSaasUsingPOSTResponse(artifactRequest).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * registerArtifactV2
   * @param artifactRequest artifactRequest
   */
  registerArtifactV2UsingPOSTResponse(
    artifactRequest: ArtifactRequest,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = artifactRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifacts/registerV2`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * registerArtifactV2
   * @param artifactRequest artifactRequest
   */
  registerArtifactV2UsingPOST(
    artifactRequest: ArtifactRequest,
  ): __Observable<null> {
    return this.registerArtifactV2UsingPOSTResponse(artifactRequest).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * uploadArtifactsZip
   * @param params The `UiArtifactsControllerService.UploadArtifactsZipUsingPOSTParams` containing the following parameters:
   *
   * - `file`: file
   *
   * - `artifactRequest`: artifactRequest
   */
  uploadArtifactsZipUsingPOSTResponse(
    params: UiArtifactsControllerService.UploadArtifactsZipUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.file != null) {
      __formData.append('file', params.file as string | Blob);
    }
    if (params.artifactRequest != null) {
      __formData.append(
        'artifactRequest',
        params.artifactRequest as string | Blob,
      );
    }
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifacts/upload`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * uploadArtifactsZip
   * @param params The `UiArtifactsControllerService.UploadArtifactsZipUsingPOSTParams` containing the following parameters:
   *
   * - `file`: file
   *
   * - `artifactRequest`: artifactRequest
   */
  uploadArtifactsZipUsingPOST(
    params: UiArtifactsControllerService.UploadArtifactsZipUsingPOSTParams,
  ): __Observable<null> {
    return this.uploadArtifactsZipUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * deleteArtifact
   * @param artifactId artifactId
   */
  deleteArtifactUsingDELETEResponse(
    artifactId: string,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/artifacts/${encodeURIComponent(String(artifactId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * deleteArtifact
   * @param artifactId artifactId
   */
  deleteArtifactUsingDELETE(artifactId: string): __Observable<null> {
    return this.deleteArtifactUsingDELETEResponse(artifactId).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * promoteArtifact
   * @param params The `UiArtifactsControllerService.PromoteArtifactUsingPOSTParams` containing the following parameters:
   *
   * - `ciId`: ciId
   *
   * - `artifactId`: artifactId
   *
   * @return OK
   */
  promoteArtifactUsingPOSTResponse(
    params: UiArtifactsControllerService.PromoteArtifactUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<Artifact>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/artifacts/${encodeURIComponent(
          String(params.ciId),
        )}/promote/${encodeURIComponent(String(params.artifactId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Artifact>;
      }),
    );
  }
  /**
   * promoteArtifact
   * @param params The `UiArtifactsControllerService.PromoteArtifactUsingPOSTParams` containing the following parameters:
   *
   * - `ciId`: ciId
   *
   * - `artifactId`: artifactId
   *
   * @return OK
   */
  promoteArtifactUsingPOST(
    params: UiArtifactsControllerService.PromoteArtifactUsingPOSTParams,
  ): __Observable<Artifact> {
    return this.promoteArtifactUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as Artifact),
    );
  }

  /**
   * getArtifactByClusterId
   * @param clusterId clusterId
   * @return OK
   */
  getArtifactByClusterIdUsingGETResponse(
    clusterId: string,
  ): __Observable<
    __StrictHttpResponse<{ [key: string]: { [key: string]: Artifact } }>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/artifacts/${encodeURIComponent(String(clusterId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{
          [key: string]: { [key: string]: Artifact };
        }>;
      }),
    );
  }
  /**
   * getArtifactByClusterId
   * @param clusterId clusterId
   * @return OK
   */
  getArtifactByClusterIdUsingGET(
    clusterId: string,
  ): __Observable<{ [key: string]: { [key: string]: Artifact } }> {
    return this.getArtifactByClusterIdUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as { [key: string]: { [key: string]: Artifact } }),
    );
  }
}

module UiArtifactsControllerService {
  /**
   * Parameters for getAllUsingGET
   */
  export interface GetAllUsingGETParams {
    /**
     * classified
     */
    classified?: boolean;

    /**
     * artifactory
     */
    artifactory?: string;
  }

  /**
   * Parameters for getArtifactByApplicationNameUsingGET
   */
  export interface GetArtifactByApplicationNameUsingGETParams {
    /**
     * clusterId
     */
    clusterId: string;

    /**
     * applicationName
     */
    applicationName: string;
  }

  /**
   * Parameters for getArtifactsByResourceNameAndResourceTypeUsingGET
   */
  export interface GetArtifactsByResourceNameAndResourceTypeUsingGETParams {
    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for updateReleaseStreamUsingPOST
   */
  export interface UpdateReleaseStreamUsingPOSTParams {
    /**
     * updatedReleaseStream
     */
    updatedReleaseStream: string;

    /**
     * includeApps
     */
    includeApps: Array<string>;

    /**
     * excludeApps
     */
    excludeApps: Array<string>;

    /**
     * currentReleaseStream
     */
    currentReleaseStream: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for promoteArtifactByArtifactCiNameUsingPOST
   */
  export interface PromoteArtifactByArtifactCiNameUsingPOSTParams {
    /**
     * ciName
     */
    ciName: string;

    /**
     * artifactId
     */
    artifactId: string;
  }

  /**
   * Parameters for generateArtifactPushCredentialsUsingPOST
   */
  export interface GenerateArtifactPushCredentialsUsingPOSTParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * appName
     */
    appName: string;
  }

  /**
   * Parameters for generateArtifactPushCredentialsV2UsingPOST
   */
  export interface GenerateArtifactPushCredentialsV2UsingPOSTParams {
    /**
     * registrationValue
     */
    registrationValue: string;

    /**
     * registrationType
     */
    registrationType: string;

    /**
     * artifactName
     */
    artifactName: string;
  }

  /**
   * Parameters for generateArtifactPushCredentialsV3UsingPOST
   */
  export interface GenerateArtifactPushCredentialsV3UsingPOSTParams {
    /**
     * metadata
     */
    metadata: any;

    /**
     * artifactName
     */
    artifactName: string;
  }

  /**
   * Parameters for uploadArtifactsZipUsingPOST
   */
  export interface UploadArtifactsZipUsingPOSTParams {
    /**
     * file
     */
    file: Blob;

    /**
     * artifactRequest
     */
    artifactRequest: string;
  }

  /**
   * Parameters for promoteArtifactUsingPOST
   */
  export interface PromoteArtifactUsingPOSTParams {
    /**
     * ciId
     */
    ciId: string;

    /**
     * artifactId
     */
    artifactId: string;
  }
}

export { UiArtifactsControllerService };
